import { render, staticRenderFns } from "./ReportsPartialPayoffCases.vue?vue&type=template&id=b3010e30"
import script from "./ReportsPartialPayoffCases.vue?vue&type=script&lang=js"
export * from "./ReportsPartialPayoffCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports